import { IPharmacy } from "@/shared/types/interfaces/pharmacy";
import { IProvider, IProviderAddress } from "@/shared/types/interfaces/provider";

export const getFullAddress = ({ addressLine1, addressLine2, city, state, zip }: IPharmacy | IProviderAddress) =>
  [addressLine1, addressLine2, city, state].filter(Boolean).join(', ') + ' ' + zip?.trim().substring(0, 5);

export const formatPharmaciesList = (list: IPharmacy[] = []) =>
  list.map(item => ({
    ...item,
    display: `${item.name}, ${getFullAddress(item)}`
  }));

export const formatProvidersList = (list: IProvider[] = []) =>
  list.map(item => ({
    ...item,
    display: `${item.firstName} ${item.lastName}, ${getFullAddress(item.address)}`
  }));

interface IUser {
  firstName: string,
  lastName: string
}

export const getFullName = (user: IUser) => `${user.firstName} ${user.lastName}`;

export const buildSpiNpiStringForProvider = (provider: IProvider) => {
    return `${provider.npi}_${provider.spi}`;
};